/*
 * @Author: Tina Huang
 * @Date: 2024-03-15 11:08:48
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-07-25 17:31:59
 * @Description:
 */

type LIVE_DETAIL = {
  url: string
  title: string
}

export type LIVE_TYPE = {
  id: number
  title: string
  child?: LIVE_DETAIL[]
  time?: string
  done?: boolean
  cover?: string
  link?: string
  tag?: string[]
  direction?: string
}

export const lives: LIVE_TYPE[] = [
  {
    id: 1,
    title: '基本公式解析',
    time: '2024/01/14',
    done: true,
  },
  {
    id: 2,
    title: 'Database的高级用法介绍',
  },
  {
    id: 3,
    title: '快捷按钮的妙用',
  },
  {
    id: 4,
    title: '模板设计思路和扩展',
  },
  {
    id: 19,
    title: '用公式进行进度管理',
    time: '2024/07/25',
    done: true,
    child: [
      {
        title: '❤️ 强迫症福音！超好看“血条”进度条',
        url: '//player.bilibili.com/player.html?isOutside=true&aid=1206253333&bvid=BV1ef421q7Wq&cid=1619050633&p=1',
      },
      {
        title: '用公式计算打卡率｜管理你的打卡进度',
        url: '//player.bilibili.com/player.html?isOutside=true&aid=1154097846&bvid=BV1VZ421E73y&cid=1535602311&p=1',
      },
    ],
  },
  {
    id: 18,
    title: '快捷打卡按钮+积分打卡统计',
    time: '2024/03/18',
    done: true,
    child: [
      {
        //
        url: '//player.bilibili.com/player.html?aid=1151842591&bvid=BV1SZ421h7EY&cid=1473781776&p=1',
        title: 'Notion教程vol.5｜快捷打卡按钮+积分打卡统计 · 原来公式这么好玩',
      },
    ],
  },
  {
    id: 5,
    title: '简单模板解析（热力打卡）',
    time: '2024/02/24',
    done: true,
    child: [
      {
        url: '//player.bilibili.com/player.html?aid=1201006465&bvid=BV1gF4m1j7Nj&cid=1450902433&p=1',
        title: '😄 打卡还能这么玩！用Notion建立自己的打卡热力图吧！',
      },
    ],
  },
  {
    id: 6,
    title: '如何设计自己的数据库关联',
    cover: './assets/templates/relation.jpg',
    link: 'https://www.bilibili.com/video/BV1ew411r7Mk/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['formula2.0', 'relation'],
    direction: 'row',
    done: true,
  },
  {
    id: 7,
    title: '⏰ 用Notion做自动化时间管理',
    cover: './assets/templates/timer.jpeg',
    link: 'https://www.bilibili.com/video/BV1fh4y187pd/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['formula', 'tempalte button', 'automation'],
    direction: 'row',
    done: true,
  },
  {
    id: 8,
    title: 'Notion公式2.0版本解析教程',
    cover: './assets/templates/formula2.0.jpeg',
    link: 'https://www.bilibili.com/video/BV1Qm4y1V7pn/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['formula'],
    direction: 'row',
    done: true,
  },
  {
    id: 9,
    title: '不得不看的进阶教程',
    cover: './assets/templates/video-month.jpg',
    link: 'https://www.bilibili.com/video/BV1R14y1C7me/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['relation', 'rollup'],
    direction: 'row',
    done: true,
  },
  {
    id: 10,
    title: '🆕 模版按钮升级啦',
    cover: './assets/templates/video-button.jpg',
    link: 'https://www.bilibili.com/video/BV1hX4y1o7Ab/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['tempalte button'],
    direction: 'row',
    done: true,
  },
  {
    id: 11,
    title: '在数据库内自动生成体重曲线',
    cover: './assets/templates/video-tizhong.jpg',
    link: 'https://www.bilibili.com/video/BV1tc411E7EZ/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['formula', '公式计算'],
    direction: 'row',
    done: true,
  },
  {
    id: 12,
    title: '设置循环任务，自动生成事件',
    cover: './assets/templates/video-repeat.jpg',
    link: 'https://www.bilibili.com/video/BV1qv4y1x7Ft/',
    tag: ['Repeat', '循环事件', '自动化'],
    direction: 'row',
    done: true,
  },
  {
    id: 13,
    title: '自定义打卡项以及打卡汇总',
    cover: './assets/templates/video-daka.png',
    link: 'https://www.bilibili.com/video/BV1qW4y157tC/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['relation & rollup'],
    direction: 'row',
    done: true,
  },
  {
    id: 14,
    title: '游戏闯关式升级人生模版教程',
    cover: './assets/templates/video-habit.png',
    link: 'https://www.bilibili.com/video/BV1Q84y1z7fZ/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['自律计划', '模版教程'],
    direction: 'row',
    done: true,
  },
  {
    id: 15,
    title: '打造个人积分打卡系统教程',
    cover: './assets/templates/video-jifen.jpg',
    link: 'https://www.bilibili.com/video/BV1kV4y1s7bE/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['高阶用法', '公式进度条'],
    direction: 'row',
    done: true,
  },
  {
    id: 16,
    title: '自选emoji的进度条制作',
    cover: './assets/emojis.png',
    link: 'https://www.bilibili.com/video/BV1gP411N76P/?vd_source=4f6a967f85ea30e5aca58f548a5c350e',
    tag: ['原生进度条', '自定义进度条'],
    direction: 'row',
    done: true,
  },
  {
    id: 17,
    title: '遇到多位小数怎么办，一步搞定',
    cover: './assets/nums.jpeg',
    link: 'https://mp.weixin.qq.com/s/lsRpsCu0HlgOsjiqkzxgng',
    tag: ['formula', '保留小数位'],
    direction: 'row',
    done: true,
  },
]
